import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TProviderBrand, adaptProviderBrandFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER_BRAND } from '../../backend-paths';


export const providerBrandDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ADMIN_PROVIDER_BRAND}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_PROVIDER_BRAND}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptProviderBrandFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProviderBrand> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerBrandDeleteSlice = createSlice({
	name: 'providerBrandDeleteSlice',
	initialState,
	reducers: {
		clearProviderBrandDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerBrandDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[providerBrandDeleteApi.fulfilled.type]: (state, action: PayloadAction<TProviderBrand>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerBrandDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProviderBrandDeleteSelector = () => useAppSelector(state => state[providerBrandDeleteSlice.name]);

export const { clearProviderBrandDelete } = providerBrandDeleteSlice.actions;
